import { toAbsoluteUrl } from "../../../utils/CommonHelper";
import { ItemConst } from "../../../constants/ItemConst";
import { useState, useEffect } from "react";
import { ReceiptDialog } from "./Receipt";
import { DetailDialog } from "./Details";
import { useIntl } from "react-intl";

export const Home = () => {
  const [inputValues, setInputValues] = useState(ItemConst.map(() => 0));
  const [item, setItem] = useState();
  const [language, setLanguage] = useState(
    localStorage.getItem("locale") || "zh"
  );
  const [showScrollTop, setShowScrollTop] = useState(false); // State for scroll-to-top button visibility
  const intl = useIntl();

  const handleInputChange = (index, operation) => {
    setInputValues((prevValues) => {
      const newValues = [...prevValues];
      if (operation === "increment") {
        newValues[index] += 1;
      } else if (operation === "decrement" && newValues[index] > 0) {
        newValues[index] -= 1;
      }
      return newValues;
    });
  };

  const handleLanguageChange = () => {
    const newLanguage = language === "en" ? "zh" : "en";
    console.log(`update:language to ${newLanguage}`);
    localStorage.setItem("locale", newLanguage);
    setLanguage(newLanguage);
    window.location.reload();
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className="w-100 h-100"
      style={{ background: "#181818", position: "relative" }}
    >
      <i
        className="bi bi-translate"
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          width: "40px",
          height: "40px",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          borderRadius: "5px",
          color: "white",
          cursor: "pointer",
          fontSize: "24px",
          textAlign: "center",
        }}
        onClick={handleLanguageChange}
      />

      <ReceiptDialog inputValues={inputValues} items={ItemConst} />
      <DetailDialog itemID={item} />
      <img
        src={toAbsoluteUrl("image/item/1.jpeg")}
        className="skeleton"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "5px",
          padding: "5px",
        }}
      >
        {ItemConst &&
          ItemConst.map((item, index) => (
            <div key={index} style={{ position: "relative" }}>
              <img
                data-bs-toggle="modal"
                data-bs-target="#detailModal"
                src={toAbsoluteUrl(item.image)}
                alt={item.title}
                className="skeleton"
                style={{
                  width: "100%",
                  height: "200px",
                  objectFit: "cover",
                }}
                onClick={() => setItem(item.title)}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "2px",
                  right: "2px",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "rgba(0, 0, 0, 0.7)",
                  borderRadius: "5px",
                  padding: "5px",
                }}
              >
                <button
                  onClick={() => handleInputChange(index, "decrement")}
                  style={{
                    backgroundColor: "#f5be09",
                    border: "none",
                    borderRadius: "5px",
                    width: "24px",
                    height: "24px",
                    color: "#181818",
                    fontWeight: "bold",
                    fontSize: "14px",
                    cursor: "pointer",
                    lineHeight: "1",
                    padding: "0",
                  }}
                >
                  -
                </button>
                <input
                  type="number"
                  value={inputValues[index]}
                  readOnly
                  style={{
                    width: "40px",
                    textAlign: "center",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                />
                <button
                  onClick={() => handleInputChange(index, "increment")}
                  style={{
                    backgroundColor: "#f5be09",
                    border: "none",
                    borderRadius: "5px",
                    width: "24px",
                    height: "24px",
                    color: "#181818",
                    fontWeight: "bold",
                    fontSize: "14px",
                    cursor: "pointer",
                    lineHeight: "1",
                    padding: "0",
                  }}
                >
                  +
                </button>
              </div>
            </div>
          ))}
      </div>
      <img
        src={toAbsoluteUrl("image/item/45.jpeg")}
        className="skeleton"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
      <button
        data-bs-toggle="modal"
        data-bs-target="#receiptModal"
        style={{
          position: "fixed",
          bottom: "20px",
          left: "50%",
          transform: "translateX(-50%)",
          backgroundColor: "#80FF00",
          color: "#181818",
          fontWeight: "bold",
          padding: "10px 20px",
          borderRadius: "5px",
          border: "none",
          cursor: "pointer",
        }}
      >
        {intl.formatMessage({ id: "confirm" })}
      </button>

      {/* Back to Top Button */}
      {showScrollTop && (
        <i
          className="bi bi-arrow-up"
          style={{
            position: "fixed",
            bottom: "20px",
            right: "10px",
            width: "40px",
            height: "40px",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            borderRadius: "5px",
            color: "white",
            cursor: "pointer",
            fontSize: "24px",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={scrollToTop}
        />
      )}
    </div>
  );
};
